// extracted by mini-css-extract-plugin
export default {"UploadError":"_UploadError--CDYzZ","UploadErrorMessage":"_UploadErrorMessage--x3BqL"};